import axios from 'axios'
import fileDownload from 'js-file-download'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getInternalPurchaseOrders({ commit }, params = {}) {
    return axios.get('/internal-purchase-orders/search', { params })
  },
  getInternalPurchaseOrder({ commit }, id) {
    return axios.get(`/internal-purchase-orders/${id}`)
  },
  createInternalPurchaseOrder({ commit }, data) {
    return axios.post('/internal-purchase-orders', data)
  },
  updateInternalPurchaseOrder({ commit }, data) {
    return axios.put(`/internal-purchase-orders/${data.id}`, data)
  },
  updateInternalPurchaseOrderStatus({ commit }, data) {
    return axios.put(`/internal-purchase-orders/${data.id}/change-status`, data)
  },
  updateItemsAdditional({ commit }, {id, data}) {
    return axios.put(`/internal-purchase-orders/${id}/items-additional`, data)
  },
  downloadInternalPurchaseOrder({ commit }, data) {
    return axios
      .get(`/internal-purchase-orders/${data.id}/download`, { responseType: 'blob' })
      .then((response) => {
        fileDownload(response.data, `${data.document_name}.pdf`)
      })
  },
  approveInternalPurchaseOrder({ commit }, data) {
    return axios.post(`/internal-purchase-orders/${data.id}/approve`)
  },
  deleteInternalPurchaseOrder({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/internal-purchase-orders/${payload.id}/delete`, payload)
  },
  rejectInternalPurchaseOrder({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/internal-purchase-orders/${payload.id}/reject`, payload)
  },
  cancelInternalPurchaseOrder({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/internal-purchase-orders/${payload.id}/cancel`, payload)
  },
  xeroSyncInternalPurchaseOrder({ commit }, ipo) {
    return axios.post(`/internal-purchase-orders/${ipo.id}/xero-sync`, {})
  }
}
